import appStore from 'store';
import api from './api';
import utils from "@/entries/HedgeCenter/MarketSheet/utils";

const store = {

    namespaced: true,

    state: {
        configurations: [],
        brushConfigurations:[],
        machineTypeOptions: [
            {key:'SYNC_INDEX_PRICE', label: '外部同步指数价'},
            {key:'SYNC_DEPTH_AND_DEAL', label:'外部同步行情和成交'},
        ],
        machineBrushTypes:[{code: 'BY_QUANTITY',desc: '代币数量'},{code : 'BY_QUOTE',desc: '成交额'}],
        exchangeSrcOp1: [
            {key:'BINANCE', label: '币安'},
            {key:'HUOBI', label:'火币'},
            {key:'OKEX', label:'OKEX'},
            {key:'FTX', label:'FTX'},
            {key:'COINEX', label:'COINEX'},
            {key:'ZB', label:'ZB'},
            {key:'MXC', label:'MXC'},
            {key:'UNISWAP', label:'UNISWAP'},
            {key:'PANCAKE', label:'PANCAKE'},
            {key:'GATEIO', label: 'GATEIO'},
            {key:'FIXED_ETH', label:'固定锚定以太坊'},
            {key:'FUND', label:'平台基金'},
            {key:'BIKI', label:'BIKI'},
            {key:'BITMART', label:'BITMART'},
            {key:'KUCOIN', label:'KUCOIN'},
            {key:'PANGOLIN', label:'PANGOLIN'},
            {key:'LBANK', label:'LBANK'},
            {key:'SPOOKYSWAP', label:'SPOOKYSWAP'},
            {key:'SHIBASWAP', label:'SHIBASWAP'},
            {key:'JOE', label:'JOE'},
            {key:'SUSHI', label:'SUSHI'},
            {key:'RAYDIUM', label:'RAYDIUM'},
            {key:'QUICKSWAP', label:'QUICKSWAP'},
        ],
        exchangeSrcOp2: [
            {key:'BINANCE', label: '币安'},
            {key:'HUOBI', label:'火币'},
            {key:'OKEX', label:'OKEX'},
            {key:'FTX', label:'FTX'},
            {key:'COINEX', label:'COINEX'},
            {key:'ZB', label:'ZB'},
            {key:'MXC', label:'MXC'},
            {key:'GATEIO', label: 'GATEIO'},
            {key:'BIKI', label:'BIKI'},
            {key:'BITMART', label:'BITMART'},
            {key:'KUCOIN', label:'KUCOIN'},
            {key:'LBANK', label:'LBANK'},
        ],
        exchangeSrcOp3: [
            {key:'UNISWAP', label:'UNISWAP'},
            {key:'PANCAKE', label:'PANCAKE'},
            {key:'BAKERY', label:'BAKERY'},
            {key:'FIXED_ETH', label:'固定锚定以太坊'},
            {key:'FUND', label:'平台基金'},
            {key:'MDEX', label:'MDEX'},
            {key:'PANGOLIN', label:'PANGOLIN'},
            {key:'SPOOKYSWAP', label:'SPOOKYSWAP'},
            {key:'SHIBASWAP', label:'SHIBASWAP'},
            {key:'JOE', label:'JOE'},
            {key:'SUSHI', label:'SUSHI'},
            {key:'RAYDIUM', label:'RAYDIUM'},
            {key:'QUICKSWAP', label:'QUICKSWAP'},
            {key:'FIXED_USDT', label:'固定锚定内部价'},
            {key:'CUSTOM_PRICE', label:'自定义指数价'},
        ],
        customPosition:{
            "bidLowPlaceRegion":"买盘低档位区间",
            "bidLowMajorProbability":"买盘低档位大部分概率",
            "bidLowMajorMultiple":"买盘低档位大部分倍数",
            "bidLowOtherMultiple":"买盘低档位其余倍数",
            "askLowPlaceRegion":"卖盘低档位区间",
            "askLowMajorProbability":"卖盘低档位大部分概率",
            "askLowMajorMultiple":"卖盘低档位大部分倍数",
            "askLowOtherMultiple":"卖盘低档位其余倍数",

            "bidMediumPlaceRegion":"买盘中档位区间",
            "bidMediumMajorProbability":"买盘中档位大部分概率",
            "bidMediumMajorMultiple":"买盘中档位大部分倍数",
            "bidMediumOtherMultiple":"买盘中档位其余倍数",
            "askMediumPlaceRegion":"卖盘中档位区间",
            "askMediumMajorProbability":"卖盘中档位大部分概率",
            "askMediumMajorMultiple":"卖盘中档位大部分倍数",
            "askMediumOtherMultiple":"卖盘中档位其余倍数",

            "bidHighPlaceRegion":"买盘高档位区间",
            "bidHighMajorProbability":"买盘高档位大部分概率",
            "bidHighMajorMultiple":"买盘高档位大部分倍数",
            "bidHighOtherMultiple":"买盘高档位其余倍数",
            "askHighPlaceRegion":"卖盘高档位区间",
            "askHighMajorProbability":"卖盘高档位大部分概率",
            "askHighMajorMultiple":"卖盘高档位大部分倍数",
            "askHighOtherMultiple":"卖盘高档位其余倍数",
        },
    },

    mutations: {
        setBrushConfigurations(state, payload) {
            // 将时间戳换成本地时间
            for (let i in payload){
                payload[i].createdTime = utils.getLocalTime(payload[i].createdTime)
            }
            state.brushConfigurations = payload
        },

        setConfigurations(state, payload) {
            for(let i in payload){
                for (let key in payload[i]){
                    // 自定义盘口配置映射
                    if (state.customPosition.hasOwnProperty(key)){
                        let region = payload[i][key].split(",")
                        let lowerName = key + "Lower"
                        let upperName = key + "Upper"
                        payload[i][lowerName] = parseFloat(region[0])
                        payload[i][upperName] = parseFloat(region[1])
                    }

                    // 交易所列表转字符串
                    if (key === 'srcExchanges'){
                        payload[i][key] = payload[i][key].toString()
                    }

                    // 币对等级数字转字符串
                    payload[i].level = payload[i].level.toString()

                    // 指数价手动偏移开关映射
                    if (payload[i].priceManualDeviateFlag === true || payload[i].priceManualDeviateFlag === "1"){
                        payload[i].priceManualDeviateFlag = '1'
                    } else {
                        payload[i].priceManualDeviateFlag = '0'
                    }

                    // 动态买卖回撤开关映射
                    if (payload[i].priceAutoDeviateFlag === true || payload[i].priceAutoDeviateFlag === '1'){
                        payload[i].priceAutoDeviateFlag = '1'
                    } else{
                        payload[i].priceAutoDeviateFlag = '0'
                    }

                    // 自定义盘口配置开关映射
                    if (payload[i].customPositionFlag === true || payload[i].customPositionFlag === '1'){
                        payload[i].customPositionFlag = '1'
                    } else{
                        payload[i].customPositionFlag = '0'
                    }

                    // 行情同步开关映射
                    if (payload[i].enabledFlag === true || payload[i].enabledFlag === "1"){
                        payload[i].enabledFlag = '1'
                    } else {
                        payload[i].enabledFlag = '0'
                    }

                    // 成交刷量开关映射
                    if ( payload[i].dealFlag === true || payload[i].dealFlag === "1"){
                        payload[i].dealFlag = '1'
                    } else {
                        payload[i].dealFlag = '0'
                    }
                }
            }
            state.configurations = payload;
        },
    },

    actions: {
        queryConfigurations({commit}) {
            api.getAllConfig().then(response => {
                commit('setConfigurations', response.data);
            })
        },

        updateConfiguration({commit}, data) {
            return api.updatePairConfig(data);
        },

        queryBrushConfigurations({commit}) {
            api.queryBrushConfig().then(response =>{
                commit('setBrushConfigurations', response.data);
            })
        }
    }
}

appStore.registerModule('quotationCache', store)
